
import { Component, Inject } from '@angular/core' ;
import { MAT_DIALOG_DATA } from "@angular/material/dialog" ;

@Component({
    selector: 'errorhandlingfrontend-alert-dialog',
    templateUrl: './errorhandlingfrontend-alert-dialog.component.html',
    styleUrls: ['./errorhandlingfrontend-alert-dialog.component.scss'],
})
export class ErrorHandlingFrontendAlertDialogComponent
{

    // Le titre à mettre sur la boîte de dialogue.
    public dialogTitle = "" ;

    // La classe pour le titre (par défaut c’est un message d’erreur)
    public titleClass = "error-title" ;

    // La classe pour l’icône
    public iconClass = "error-icon" ;

    // L’icône à afficher
    public icon = "error" ;

    // Le texte pour la boîte de dialogue.
    public dialogText = "" ;

    // Si un message d’erreur complet peut être affiché en option, le message complet.
    public fullMessage = "" ;

    // Si un message d’erreur complet peut être affiché en option.
    public canShowFullMessage = false ;

    // Si un bouton annuler doit être disponible.
    public canCancel = false ;

    // Quand on peut annuler, c’est le nom à mettre sur le bouton d’action.
    public actionButtonName : string | null = null ;

    // Si on a affiché le message complet
    public fullMessageShown = false ;

    public constructor (@Inject(MAT_DIALOG_DATA) data : any) {
        if ( "DialogTitle" in data )
            this.dialogTitle = data["DialogTitle"] ;
        if ( "Level" in data )
        {
            if ( data["Level"] === "Info" )
            {
                this.titleClass = "info-title" ;
                this.iconClass = "info-icon" ;
                this.icon = "info" ;
            }
        }
        if ( ("DialogText" in data) && (typeof data["DialogText"] === "string") )
            this.dialogText = data["DialogText"].replace(/(?:\r\n|\r|\n)/g,"<br/>") ;
        if ( ("FullMessage" in data) && (typeof data["FullMessage"] === "string") )
            this.fullMessage = data["FullMessage"].replace(/(?:\r\n|\r|\n)/g,"<br/>") ;
        if ( "CanShowFullMessage" in data )
            this.canShowFullMessage = data["CanShowFullMessage"] ;
        if ( "CanCancel" in data )
            this.canCancel = data["CanCancel"] ;
        if ( "ActionButtonName" in data )
            this.actionButtonName = data["ActionButtonName"] ;
        this.fullMessageShown = false ;
    }

    /**
     * Appelé quand l’utilisateur clique sur le bouton pour afficher ou cacher le message complet.
     */
    public onShowHideFullMessage(): void {
        if (this.canShowFullMessage) {
            this.fullMessageShown = !this.fullMessageShown;
        }
    }
}

